import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'unistore/react';
import pick from 'lodash/fp/pick';

import { actions } from '../store/PlanStore';
import Button from 'common/components/Button';
import { Icon } from 'common/components/Icon';
import { TranslatedMessage } from 'common/components/Intl';
import CheckoutDrawer from './CheckoutDrawer';
import segment from 'common/segment';
import {
  selectCartQuantity,
  selectSelectedPodsTotalQuantity,
} from '../store/selectors';

export function PlanCart({
  cartQuantity,
  navigateToNextStep,
  nextButtonContent,
  selectedAddOns,
  selectedPods,
  notEnoughPodsInCart,
}) {
  const [drawerIsVisible, setDrawerIsVisible] = useState(false);

  const toggleCart = () => {
    const eventName = !drawerIsVisible ? 'Opened' : 'Closed';
    segment.track('AS Builder Cart', { action: eventName });
    setDrawerIsVisible(!drawerIsVisible);
  };

  let detailsTranslationKey = 'show_details';
  if (drawerIsVisible) {
    detailsTranslationKey = 'hide_details';
  } else if (!drawerIsVisible && notEnoughPodsInCart) {
    detailsTranslationKey = 'minimum';
  }

  const handleNextClick = () => {
    segment.track('AS Builder Next CTA Selected');
    navigateToNextStep();
  };

  return (
    <div className="build-your-plan__checkout">
      {drawerIsVisible && (
        <CheckoutDrawer
          closeModal={() => setDrawerIsVisible(false)}
          selectedAddOns={selectedAddOns}
          selectedPods={selectedPods}
        />
      )}
      <div className="build-your-plan__footer-wrap">
        <button className="build-your-plan__footer-info" onClick={toggleCart}>
          <span className="build-your-plan__footer-amount">
            <TranslatedMessage
              className="text--body"
              id="plan_builder.cart.pods_in_cart"
              values={{ cartQuantity }}
            />
            <Icon
              alt=""
              className="build-your-plan__footer-icon"
              name={drawerIsVisible ? 'chevron-down' : 'chevron-up'}
            />
          </span>
          <span className="build-your-plan__show-details subheading--small">
            <TranslatedMessage
              id={`plan_builder.cart.${detailsTranslationKey}`}
            />
          </span>
        </button>
        <Button
          className="button--vivid"
          disabled={notEnoughPodsInCart}
          onClick={handleNextClick}
        >
          {nextButtonContent}
        </Button>
      </div>
    </div>
  );
}

PlanCart.propTypes = {
  cartQuantity: PropTypes.number.isRequired,
  navigateToNextStep: PropTypes.func.isRequired,
  nextButtonContent: PropTypes.node.isRequired,
  selectedAddOns: PropTypes.object.isRequired,
  selectedPods: PropTypes.object.isRequired,
  notEnoughPodsInCart: PropTypes.bool.isRequired,
};

export default connect(
  state => ({
    ...pick(['selectedPods', 'selectedAddOns'])(state),
    cartQuantity: selectCartQuantity(state),
    notEnoughPodsInCart:
      state.minimumSubscriptionItems > selectSelectedPodsTotalQuantity(state),
  }),
  actions
)(PlanCart);
